import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import LaunchBanner from "@/components/landing/LaunchBanner";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Problem from "@/components/landing/Problem";
import Stakes from "@/components/landing/Stakes";
import Process from "@/components/landing/Process";
import Platforms from "@/components/landing/Platforms";
import Proof from "@/components/landing/Proof";
import Pricing from "@/components/landing/Pricing";
import Campaign from "@/components/landing/Campaign";
import About from "@/components/landing/About";
import Webinar from "@/components/landing/Webinar";
import Checklist from "@/components/landing/Checklist";
import AuditForm from "@/components/landing/AuditForm";
import Footer from "@/components/landing/Footer";
import Admin from "@/pages/Admin";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function Landing() {
  return (
    <>
      <Nav />
      <main>
        <LaunchBanner />
        <Hero />
        <Marquee />
        <Manifesto />
        <Problem />
        <Stakes />
        <Process />
        <Platforms />
        <Proof />
        <Pricing />
        <Campaign />
        <About />
        <Webinar />
        <Checklist />
        <AuditForm />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App text-white overflow-x-clip">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}
